export function getTypo3BackendUrl(path: string): URL {
	return new URL(
		path,
		import.meta.env.VITE_TYPO3_BACKEND_BASE || "http://localhost/",
	);
}
